import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

const Collapse = ({
  classes = "",
  defaultExpanded = true,
  label = "",
  children,
}) => {
  return (
    <div className={classes}>
      <Accordion defaultExpanded={defaultExpanded}>
        <AccordionSummary expandIcon={<ArrowRightIcon fontSize="large" />}>
          {label}
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    </div>
  );
};

export default Collapse;
